<template>
    <g>
        <g>
            <g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#66499E" d="M462.011,102.713h82.873c15.336,0,28.951,5.949,40.848,17.843
						c11.893,11.896,17.791,25.511,17.695,40.847c0,16.319-2.975,30.082-8.922,41.289c-5.949,11.207-14.871,17.009-26.764,17.4
						l29.049,29.492c4.719,4.622,7.078,10.716,7.078,18.285c-0.295,15.631-8.16,23.446-23.594,23.446h-0.59
						c-7.865,0-15.582-3.834-23.15-11.502l-47.188-58.542c-7.963-8.454-11.996-16.564-12.092-24.331
						c0-15.926,7.963-23.838,23.889-23.741l16.662-0.147c12.484,0.198,18.629-3.588,18.434-11.354
						c0-7.765-6.146-11.649-18.434-11.649h-52.053v117.674c0.096,15.729-7.816,23.594-23.742,23.594
						c-15.729,0-23.593-7.765-23.593-23.299V126.012C438.514,110.579,446.38,102.812,462.011,102.713z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M462.011,102.713h82.873
						c15.336,0,28.951,5.949,40.848,17.843c11.893,11.896,17.791,25.511,17.695,40.847c0,16.319-2.975,30.082-8.922,41.289
						c-5.949,11.207-14.871,17.009-26.764,17.4l29.049,29.492c4.719,4.622,7.078,10.716,7.078,18.285
						c-0.295,15.631-8.16,23.446-23.594,23.446h-0.59c-7.865,0-15.582-3.834-23.15-11.502l-47.188-58.542
						c-7.963-8.454-11.996-16.564-12.092-24.331c0-15.926,7.963-23.838,23.889-23.741l16.662-0.147
						c12.484,0.198,18.629-3.588,18.434-11.354c0-7.765-6.146-11.649-18.434-11.649h-52.053v117.674
						c0.096,15.729-7.816,23.594-23.742,23.594c-15.729,0-23.593-7.765-23.593-23.299V126.012
						C438.514,110.579,446.38,102.812,462.011,102.713z"/>
                    </g>
                </g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#FFFFFF" d="M462.011,91.713h82.873c15.336,0,28.951,5.949,40.848,17.843
						c11.893,11.896,17.791,25.511,17.695,40.847c0,16.319-2.975,30.082-8.922,41.289c-5.949,11.207-14.871,17.009-26.764,17.4
						l29.049,29.492c4.719,4.622,7.078,10.716,7.078,18.285c-0.295,15.631-8.16,23.446-23.594,23.446h-0.59
						c-7.865,0-15.582-3.834-23.15-11.502l-47.188-58.542c-7.963-8.454-11.996-16.564-12.092-24.331
						c0-15.926,7.963-23.838,23.889-23.741l16.662-0.147c12.484,0.198,18.629-3.588,18.434-11.354
						c0-7.765-6.146-11.649-18.434-11.649h-52.053v117.674c0.096,15.729-7.816,23.594-23.742,23.594
						c-15.729,0-23.593-7.765-23.593-23.299V115.012C438.514,99.579,446.38,91.812,462.011,91.713z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M462.011,91.713h82.873
						c15.336,0,28.951,5.949,40.848,17.843c11.893,11.896,17.791,25.511,17.695,40.847c0,16.319-2.975,30.082-8.922,41.289
						c-5.949,11.207-14.871,17.009-26.764,17.4l29.049,29.492c4.719,4.622,7.078,10.716,7.078,18.285
						c-0.295,15.631-8.16,23.446-23.594,23.446h-0.59c-7.865,0-15.582-3.834-23.15-11.502l-47.188-58.542
						c-7.963-8.454-11.996-16.564-12.092-24.331c0-15.926,7.963-23.838,23.889-23.741l16.662-0.147
						c12.484,0.198,18.629-3.588,18.434-11.354c0-7.765-6.146-11.649-18.434-11.649h-52.053v117.674
						c0.096,15.729-7.816,23.594-23.742,23.594c-15.729,0-23.593-7.765-23.593-23.299V115.012
						C438.514,99.579,446.38,91.812,462.011,91.713z"/>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#66499E" d="M781.976,126.159c0,15.729-7.571,23.645-22.709,23.741l-71.813-0.147
						c-15.926,0.198-23.939,4.228-24.036,12.092c0.195,7.472,8.258,11.158,24.184,11.06h23.151
						c47.482,0.198,71.32,20.153,71.519,59.869c0,38.635-23.792,58.051-71.371,58.247h-70.929
						c-15.631-0.097-23.446-7.815-23.446-23.151c0.097-15.631,7.863-23.348,23.299-23.151l71.076-0.442
						c15.926-0.097,23.889-4.129,23.889-12.092c0-8.06-8.063-12.041-24.184-11.944h-23.151
						c-47.286-0.097-70.929-19.562-70.929-58.395v-0.737c0-38.93,23.643-58.443,70.929-58.542h70.929
						C774.013,102.664,781.876,110.528,781.976,126.159z"/>
                        <path fill="#66499E" d="M826.066,102.86c15.728,0.099,23.741,7.866,24.036,23.299v141.857
						c-0.198,15.631-8.11,23.594-23.741,23.889c-15.729-0.394-23.594-8.354-23.594-23.889v-141.71
						C802.669,110.676,810.436,102.86,826.066,102.86z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M781.976,126.159
						c0,15.729-7.571,23.645-22.709,23.741l-71.813-0.147c-15.926,0.198-23.939,4.228-24.036,12.092
						c0.195,7.472,8.258,11.158,24.184,11.06h23.151c47.482,0.198,71.32,20.153,71.519,59.869c0,38.635-23.792,58.051-71.371,58.247
						h-70.929c-15.631-0.097-23.446-7.815-23.446-23.151c0.097-15.631,7.863-23.348,23.299-23.151l71.076-0.442
						c15.926-0.097,23.889-4.129,23.889-12.092c0-8.06-8.063-12.041-24.184-11.944h-23.151
						c-47.286-0.097-70.929-19.562-70.929-58.395v-0.737c0-38.93,23.643-58.443,70.929-58.542h70.929
						C774.013,102.664,781.876,110.528,781.976,126.159z"/>
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M826.066,102.86
						c15.728,0.099,23.741,7.866,24.036,23.299v141.857c-0.198,15.631-8.11,23.594-23.741,23.889
						c-15.729-0.394-23.594-8.354-23.594-23.889v-141.71C802.669,110.676,810.436,102.86,826.066,102.86z"/>
                    </g>
                </g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#FFFFFF" d="M792.976,115.159c0,15.729-7.571,23.645-22.709,23.741l-71.813-0.147
						c-15.926,0.198-23.939,4.228-24.036,12.092c0.195,7.472,8.258,11.158,24.184,11.06h23.151
						c47.482,0.198,71.32,20.153,71.519,59.869c0,38.635-23.792,58.051-71.371,58.247h-70.929
						c-15.631-0.097-23.446-7.815-23.446-23.151c0.097-15.631,7.863-23.348,23.299-23.151l71.076-0.442
						c15.926-0.097,23.889-4.129,23.889-12.092c0-8.06-8.063-12.041-24.184-11.944h-23.151
						c-47.286-0.097-70.929-19.562-70.929-58.395v-0.737c0-38.93,23.643-58.443,70.929-58.542h70.929
						C785.013,91.664,792.876,99.528,792.976,115.159z"/>
                        <path fill="#FFFFFF" d="M837.066,91.86c15.728,0.099,23.741,7.866,24.036,23.299v141.857
						c-0.198,15.631-8.11,23.594-23.741,23.889c-15.729-0.394-23.594-8.354-23.594-23.889v-141.71
						C813.669,99.676,821.436,91.86,837.066,91.86z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M792.976,115.159
						c0,15.729-7.571,23.645-22.709,23.741l-71.813-0.147c-15.926,0.198-23.939,4.228-24.036,12.092
						c0.195,7.472,8.258,11.158,24.184,11.06h23.151c47.482,0.198,71.32,20.153,71.519,59.869c0,38.635-23.792,58.051-71.371,58.247
						h-70.929c-15.631-0.097-23.446-7.815-23.446-23.151c0.097-15.631,7.863-23.348,23.299-23.151l71.076-0.442
						c15.926-0.097,23.889-4.129,23.889-12.092c0-8.06-8.063-12.041-24.184-11.944h-23.151
						c-47.286-0.097-70.929-19.562-70.929-58.395v-0.737c0-38.93,23.643-58.443,70.929-58.542h70.929
						C785.013,91.664,792.876,99.528,792.976,115.159z"/>
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M837.066,91.86
						c15.728,0.099,23.741,7.866,24.036,23.299v141.857c-0.198,15.631-8.11,23.594-23.741,23.889
						c-15.729-0.394-23.594-8.354-23.594-23.889v-141.71C813.669,99.676,821.436,91.86,837.066,91.86z"/>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#66499E" d="M217.118,64.889c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518
						c2.533,4.537,3.8,9.222,3.8,14.052c0,4.949-14.171,35.766-42.51,92.444c-28.342,56.682-43.748,87.261-46.222,91.737
						c-2.475,4.479-5.952,7.954-10.429,10.429c-4.479,2.475-9.191,3.712-14.141,3.712c-4.833,0-9.517-1.237-14.052-3.712
						c-4.538-2.475-8.042-5.949-10.517-10.429c-2.475-4.477-17.794-35.056-45.957-91.737C33.406,128.936,19.326,98.119,19.326,93.17
						c0-4.83,1.265-9.515,3.8-14.052c2.533-4.535,6.038-8.043,10.517-10.518c4.477-2.475,9.131-3.712,13.964-3.712
						c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,22.537,45.398,60.009,122.581
						c37.826-77.183,58.004-118.044,60.54-122.581c2.533-4.535,6.038-8.043,10.517-10.518
						C207.631,66.126,212.285,64.889,217.118,64.889z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M217.118,64.889
						c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,3.8,9.222,3.8,14.052
						c0,4.949-14.171,35.766-42.51,92.444c-28.342,56.682-43.748,87.261-46.222,91.737c-2.475,4.479-5.952,7.954-10.429,10.429
						c-4.479,2.475-9.191,3.712-14.141,3.712c-4.833,0-9.517-1.237-14.052-3.712c-4.538-2.475-8.042-5.949-10.517-10.429
						c-2.475-4.477-17.794-35.056-45.957-91.737C33.406,128.936,19.326,98.119,19.326,93.17c0-4.83,1.265-9.515,3.8-14.052
						c2.533-4.535,6.038-8.043,10.517-10.518c4.477-2.475,9.131-3.712,13.964-3.712c4.712,0,9.338,1.237,13.875,3.712
						c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,22.537,45.398,60.009,122.581c37.826-77.183,58.004-118.044,60.54-122.581
						c2.533-4.535,6.038-8.043,10.517-10.518C207.631,66.126,212.285,64.889,217.118,64.889z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="#66499E" d="M330.505,102.713c15.926,0,31.409,4.08,46.45,12.239c15.041,8.161,26.838,19.811,35.391,34.948
						c8.553,15.14,12.829,30.918,12.829,47.335c0,16.319-4.154,31.976-12.46,46.967c-8.309,14.992-19.981,26.642-35.022,34.947
						c-15.041,8.309-30.771,12.461-47.188,12.461c-16.32,0-31.976-4.152-46.966-12.461c-14.993-8.306-26.642-19.955-34.948-34.947
						c-8.309-14.991-12.46-30.647-12.46-46.967c0-16.417,4.203-32.195,12.608-47.335c8.405-15.138,20.151-26.787,35.243-34.948
						C299.07,106.793,314.579,102.713,330.505,102.713z M307.427,155.799c-7.521,4.032-13.396,9.831-17.622,17.4
						c-4.228,7.571-6.341,15.483-6.341,23.741s2.087,16.124,6.267,23.594c4.177,7.472,10.002,13.271,17.474,17.4
						c7.47,4.129,15.336,6.193,23.594,6.193c8.159,0,16-2.064,23.52-6.193s13.345-9.929,17.474-17.4
						c4.129-7.47,6.193-15.336,6.193-23.594s-2.115-16.17-6.341-23.741c-4.228-7.569-10.126-13.368-17.695-17.4
						c-7.571-4.03-15.288-6.046-23.151-6.046C322.738,149.753,314.948,151.769,307.427,155.799z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M330.505,102.713
						c15.926,0,31.409,4.08,46.45,12.239c15.041,8.161,26.838,19.811,35.391,34.948c8.553,15.14,12.829,30.918,12.829,47.335
						c0,16.319-4.154,31.976-12.46,46.967c-8.309,14.992-19.981,26.642-35.022,34.947c-15.041,8.309-30.771,12.461-47.188,12.461
						c-16.32,0-31.976-4.152-46.966-12.461c-14.993-8.306-26.642-19.955-34.948-34.947c-8.309-14.991-12.46-30.647-12.46-46.967
						c0-16.417,4.203-32.195,12.608-47.335c8.405-15.138,20.151-26.787,35.243-34.948
						C299.07,106.793,314.579,102.713,330.505,102.713z M307.427,155.799c-7.521,4.032-13.396,9.831-17.622,17.4
						c-4.228,7.571-6.341,15.483-6.341,23.741s2.087,16.124,6.267,23.594c4.177,7.472,10.002,13.271,17.474,17.4
						c7.47,4.129,15.336,6.193,23.594,6.193c8.159,0,16-2.064,23.52-6.193s13.345-9.929,17.474-17.4
						c4.129-7.47,6.193-15.336,6.193-23.594s-2.115-16.17-6.341-23.741c-4.228-7.569-10.126-13.368-17.695-17.4
						c-7.571-4.03-15.288-6.046-23.151-6.046C322.738,149.753,314.948,151.769,307.427,155.799z"/>
                    </g>
                </g>
                <g>
                    <g enable-background="new    ">
                        <path fill="#FFFFFF" d="M206.118,53.889c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518
						c2.533,4.537,3.8,9.222,3.8,14.052c0,4.949-14.171,35.766-42.51,92.444c-28.342,56.682-43.748,87.261-46.222,91.737
						c-2.475,4.479-5.952,7.954-10.429,10.429c-4.479,2.475-9.191,3.712-14.141,3.712c-4.833,0-9.517-1.237-14.052-3.712
						c-4.538-2.475-8.042-5.949-10.517-10.429c-2.475-4.477-17.794-35.056-45.957-91.737C22.406,117.936,8.326,87.119,8.326,82.17
						c0-4.83,1.265-9.515,3.8-14.052c2.533-4.535,6.038-8.043,10.517-10.518c4.477-2.475,9.131-3.712,13.964-3.712
						c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,22.537,45.398,60.009,122.581
						c37.826-77.183,58.004-118.044,60.54-122.581c2.533-4.535,6.038-8.043,10.517-10.518
						C196.631,55.126,201.285,53.889,206.118,53.889z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M206.118,53.889
						c4.712,0,9.338,1.237,13.875,3.712c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,3.8,9.222,3.8,14.052
						c0,4.949-14.171,35.766-42.51,92.444c-28.342,56.682-43.748,87.261-46.222,91.737c-2.475,4.479-5.952,7.954-10.429,10.429
						c-4.479,2.475-9.191,3.712-14.141,3.712c-4.833,0-9.517-1.237-14.052-3.712c-4.538-2.475-8.042-5.949-10.517-10.429
						c-2.475-4.477-17.794-35.056-45.957-91.737C22.406,117.936,8.326,87.119,8.326,82.17c0-4.83,1.265-9.515,3.8-14.052
						c2.533-4.535,6.038-8.043,10.517-10.518c4.477-2.475,9.131-3.712,13.964-3.712c4.712,0,9.338,1.237,13.875,3.712
						c4.535,2.475,8.07,5.982,10.605,10.518c2.533,4.537,22.537,45.398,60.009,122.581c37.826-77.183,58.004-118.044,60.54-122.581
						c2.533-4.535,6.038-8.043,10.517-10.518C196.631,55.126,201.285,53.889,206.118,53.889z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="#FFFFFF" d="M319.505,91.713c15.926,0,31.409,4.08,46.45,12.239c15.041,8.161,26.838,19.811,35.391,34.948
						c8.553,15.14,12.829,30.918,12.829,47.335c0,16.319-4.154,31.976-12.46,46.967c-8.309,14.992-19.981,26.642-35.022,34.947
						c-15.041,8.309-30.771,12.461-47.188,12.461c-16.32,0-31.976-4.152-46.966-12.461c-14.993-8.306-26.642-19.955-34.948-34.947
						c-8.309-14.991-12.46-30.647-12.46-46.967c0-16.417,4.203-32.195,12.608-47.335c8.405-15.138,20.151-26.787,35.243-34.948
						C288.07,95.793,303.579,91.713,319.505,91.713z M296.427,144.799c-7.521,4.032-13.396,9.831-17.622,17.4
						c-4.228,7.571-6.341,15.483-6.341,23.741s2.087,16.124,6.267,23.594c4.177,7.472,10.002,13.271,17.474,17.4
						c7.47,4.129,15.336,6.193,23.594,6.193c8.159,0,16-2.064,23.52-6.193s13.345-9.929,17.474-17.4
						c4.129-7.47,6.193-15.336,6.193-23.594s-2.115-16.17-6.341-23.741c-4.228-7.569-10.126-13.368-17.695-17.4
						c-7.571-4.03-15.288-6.046-23.151-6.046C311.738,138.753,303.948,140.769,296.427,144.799z"/>
                    </g>
                    <g enable-background="new    ">
                        <path fill="none" stroke="#66499E" stroke-width="14" stroke-miterlimit="10" d="M319.505,91.713
						c15.926,0,31.409,4.08,46.45,12.239c15.041,8.161,26.838,19.811,35.391,34.948c8.553,15.14,12.829,30.918,12.829,47.335
						c0,16.319-4.154,31.976-12.46,46.967c-8.309,14.992-19.981,26.642-35.022,34.947c-15.041,8.309-30.771,12.461-47.188,12.461
						c-16.32,0-31.976-4.152-46.966-12.461c-14.993-8.306-26.642-19.955-34.948-34.947c-8.309-14.991-12.46-30.647-12.46-46.967
						c0-16.417,4.203-32.195,12.608-47.335c8.405-15.138,20.151-26.787,35.243-34.948C288.07,95.793,303.579,91.713,319.505,91.713z
						 M296.427,144.799c-7.521,4.032-13.396,9.831-17.622,17.4c-4.228,7.571-6.341,15.483-6.341,23.741s2.087,16.124,6.267,23.594
						c4.177,7.472,10.002,13.271,17.474,17.4c7.47,4.129,15.336,6.193,23.594,6.193c8.159,0,16-2.064,23.52-6.193
						s13.345-9.929,17.474-17.4c4.129-7.47,6.193-15.336,6.193-23.594s-2.115-16.17-6.341-23.741
						c-4.228-7.569-10.126-13.368-17.695-17.4c-7.571-4.03-15.288-6.046-23.151-6.046
						C311.738,138.753,303.948,140.769,296.427,144.799z"/>
                    </g>
                </g>
            </g>
        </g>
        <g>
            <g>
                <path fill="#66499E" d="M154.426,69.496c11,0,15.5,7.794,10,17.32l-23.301,40.359c-5.5,9.526-14.5,9.526-20,0L97.824,86.816
				c-5.5-9.526-1-17.32,10-17.32H154.426z"/>
                <path fill="none" stroke="#66499E" stroke-width="10" stroke-miterlimit="10" d="M154.426,69.496c11,0,15.5,7.794,10,17.32
				l-23.301,40.359c-5.5,9.526-14.5,9.526-20,0L97.824,86.816c-5.5-9.526-1-17.32,10-17.32H154.426z"/>
            </g>
            <g>
                <path fill="#FFFFFF" d="M143.426,58.496c11,0,15.5,7.794,10,17.32l-23.301,40.359c-5.5,9.526-14.5,9.526-20,0L86.824,75.816
				c-5.5-9.526-1-17.32,10-17.32H143.426z"/>
                <path fill="none" stroke="#66499E" stroke-width="10" stroke-miterlimit="10" d="M143.426,58.496c11,0,15.5,7.794,10,17.32
				l-23.301,40.359c-5.5,9.526-14.5,9.526-20,0L86.824,75.816c-5.5-9.526-1-17.32,10-17.32H143.426z"/>
            </g>
        </g>
    </g>
</template>

<script>
    export default {
        name: "IconVorsiToolbarLogo"
    }
</script>

<style scoped>

</style>